package com.wintermar.inspection.core.ui.component.snackbar.util

import kotlinx.coroutines.channels.BufferOverflow
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.receiveAsFlow

object SnackBarController {
    private val _state =
        Channel<SnackBarState>(capacity = 5, onBufferOverflow = BufferOverflow.DROP_OLDEST)
    val state = _state.receiveAsFlow()

    suspend fun show(
        message: String,
        variant: SnackBarVariant = SnackBarVariant.INFO,
        position: SnackBarPosition = SnackBarPosition.TOP,
        actionValue: String? = null,
        onAction: () -> Unit = {}
    ) {
        _state.send(
            SnackBarState(
                message = message,
                variant = variant,
                position = position,
                actionValue = actionValue,
                maxWidth = getMaxWidthSnackBar(),
                onAction = onAction
            )
        )
    }
}

expect fun getMaxWidthSnackBar(): Float
